export default __webpack_public_path__ + "static/media/resources-background.9c4f2e84.png";